import { useState } from 'react';
import Modal from "react-bootstrap/Modal";

import Interface from '../../../assets/img/illustrations/interface.png';

import { AiFillPlayCircle } from 'react-icons/ai';
import { AiOutlineClose } from 'react-icons/ai';

import Navbar from "../../../components/navbar";
import HomeContent from '../../../components/homeContent';
import Footer from "../../../components/footer";


const Home = () =>{
  const [showVideo, setShowVideo] = useState(false);
  const videoVisible = () => setShowVideo(true);
  const videohidden = () => setShowVideo(false);
  return(
  <>
    <header
    className="container-fluid bg-primary header2"
    id="home">
      <div className="container h-100">
        <Navbar />
        <div className="d-flex h-75 align-items-center text-white flex-wrap">
          <div className="d-flex flex-column col-12 col-md-11 col-lg-8 mt-5 mt-lg-0">
            <h1 className="display-4 font-weight-bolder">
              Create awesome landing pages with Bang!
            </h1>
            <p className="mt-2 mt-lg-4">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
              when an unknown printer took a galley of type and scrambled it to make a type specimen book
            </p>
          </div>
          <div className="col-12 col-lg-4 d-flex justify-content-end justify-content-md-start justify-content-lg-center">
            <AiFillPlayCircle
            className="pointer"
            size={120}
            onClick={videoVisible}
            />
          </div>
        </div>
      </div>
    </header>
    <Modal
    className="modal"
    show={showVideo}
    size="xl"
    centered>
      <Modal.Header className="py-2 px-2 justify-content-end">
        <AiOutlineClose onClick={videohidden}/>
      </Modal.Header>
      <Modal.Body
      className="embed-responsive embed-responsive-16by9" >
        <iframe
        className="embed-responsive-item"
        title="demonstration"
        src="https://player.vimeo.com/video/137857207"
        />
      </Modal.Body>
    </Modal>
    <div
    id="features"
    className="container division">
        <h1 className="text-center title-responsive">
          Bang App features
        </h1>
        <div className="division2 d-flex flex-wrap">
          <div className="col-12 col-lg-4 p-2 mt-2">
            <div className="col-12 d-flex flex-column align-items-center shadow rounded p-md-5 p-4">
              <div className="col-12 col-lg-10">
                <img
                src={Interface}
                alt="..."
                className="img-fluid"
                />
              </div>
              <h2 className="text-center">
                modern interface
              </h2>
            </div>
          </div>
          <div className="col-12 col-lg-4 p-2 mt-2">
            <div className="col-12 d-flex flex-column align-items-center shadow rounded p-md-5 p-4">
              <div className="col-12 col-lg-10">
                <img
                src={Interface}
                alt="..."
                className="img-fluid"
                />
              </div>
              <h2 className="text-center">
                modern interface
              </h2>
            </div>
          </div>
          <div className="col-12 col-lg-4 p-2 mt-2">
            <div className="col-12 d-flex flex-column align-items-center shadow rounded p-md-5 p-4">
              <div className="col-12 col-lg-10">
                <img
                src={Interface}
                alt="..."
                className="img-fluid"
                />
              </div>
              <h2 className="text-center">
                modern interface
              </h2>
            </div>
          </div>
          <div className="col-12 col-lg-4 p-2 mt-2">
            <div className="col-12 d-flex flex-column align-items-center shadow rounded p-md-5 p-4">
              <div className="col-12 col-lg-10">
                <img
                src={Interface}
                alt="..."
                className="img-fluid"
                />
              </div>
              <h2 className="text-center">
                modern interface
              </h2>
            </div>
          </div>
          <div className="col-12 col-lg-4 p-2 mt-2">
            <div className="col-12 d-flex flex-column align-items-center shadow rounded p-md-5 p-4">
              <div className="col-12 col-lg-10">
                <img
                src={Interface}
                alt="..."
                className="img-fluid"
                />
              </div>
              <h2 className="text-center">
                modern interface
              </h2>
            </div>
          </div>
          <div className="col-12 col-lg-4 p-2 mt-2">
            <div className="col-12 d-flex flex-column align-items-center shadow rounded p-md-5 p-4">
              <div className="col-12 col-lg-10">
                <img
                src={Interface}
                alt="..."
                className="img-fluid"
                />
              </div>
              <h2 className="text-center">
                modern interface
              </h2>
            </div>
          </div>
        </div>
      </div>
    <HomeContent />
    <Footer />
  </>
  )
};
export default Home;